@if (isLoggedIn) {
  <div
    [ngClass]="{
      'app-bkgd': 1,
      'blue': 1,
      'fade-away': (searchTerm || filters) && !searchResultQty,
      'aside-fixed': isLoggedIn && asidePosition === 'fixed'
    }"
  ></div>
}

@if (isLoggedIn) {
  <div
    [ngClass]="{
      'app-bkgd': 1,
      'gray': 1,
      'fade-away': searchResultQty || !(searchTerm || filters),
      'aside-fixed': isLoggedIn && asidePosition === 'fixed'
    }"
  ></div>
}

@if (isLoggedIn) {
  <div
    [ngClass]="{
      'app-bkgd': 1,
      'fade-away': searchTerm || filters,
      'aside-fixed': isLoggedIn && asidePosition === 'fixed'
    }"
  ></div>
}

<main
  [ngClass]="{
    'not-logged-in': !isLoggedIn,
    'aside-fixed': isLoggedIn && asidePosition === 'fixed'
  }"
>
  @if (isLoggedIn) {
    <motn-page-header
      (clickedHamburger$)="swipedAsideOpen = true"
    ></motn-page-header>
  }

  <router-outlet></router-outlet>
</main>

@if (swipedAsideOpen) {
  <div
    class="page-aside-click-layer"
  ></div>
}

@if (isLoggedIn && platform === Platform.IOS && iosBackButtonEnabled) {
  <div
    #iosBackButton
    class="ios-back-button"
    (touchstart)="onTouchBackButton()"
    (touchend)="onUntouchBackButton(); navigateBack()"
  >
    <i class="fa-light fa-arrow-left"></i>
  </div>
}

@if (isLoggedIn) {
  <motn-page-aside
    [ngClass]="{
      'hidden': asidePosition === 'hidden',
      'swiped': swipedAsideOpen,
      'touching': touchingAside
    }"
  ></motn-page-aside>
}

@if (showTileHistory) {
  <motn-tile-history-drawer></motn-tile-history-drawer>
}

@if (isLoggedIn) {
  <motn-help-bubble></motn-help-bubble>
}

@if (showShareManagerForObject) {
  <motn-share-manager
    [object]="showShareManagerForObject"
    (closed$)="onCloseShareManager()"
  ></motn-share-manager>
}

<motn-tile-history-viewport-buffer
></motn-tile-history-viewport-buffer>

<motn-shade-tools
></motn-shade-tools>

<motn-bulk-modal
></motn-bulk-modal>

<motn-copy-toast
  [show]="copyToastService.show"
  [message]="copyToastService.message"
  [icon]="copyToastService.icon"
></motn-copy-toast>
